"use strict";
'use es6';

require("moment/locale/es");

require("moment/locale/pt-br");

require("moment/locale/en-gb");

require("moment/locale/en-au");

require("moment/locale/es-do");

require("moment/locale/de");

require("moment/locale/ja");

require("moment/locale/zh-cn");

require("moment/locale/zh-hk");

require("moment/locale/nl");

require("moment/locale/en-ca");

require("moment/locale/fi");

require("moment/locale/fr");

require("moment/locale/it");

require("moment/locale/sv");

require("moment/locale/da");

require("moment/locale/pl");

require("moment/locale/cs");

require("moment/locale/ko");

require("moment/locale/nb");